import { render, staticRenderFns } from "./doubleAuthentication.vue?vue&type=template&id=2a1838e7&scoped=true&"
import script from "./doubleAuthentication.vue?vue&type=script&lang=js&"
export * from "./doubleAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./doubleAuthentication.vue?vue&type=style&index=0&id=2a1838e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1838e7",
  null
  
)

export default component.exports